import React, { useEffect } from "react";
import SearchDropdown from "../../../app/partials/layout/SearchDropdown";
import QuickPanelToggler from "./QuickPanelToggle";
import LanguageSelector from "../../../app/partials/layout/LanguageSelector";
import UIAsideSkin from "../../../app/partials/layout/UIAsideSkin";
import UITheme from "../../../app/partials/layout/UITheme";
import UserProfile from "../../../app/partials/layout/UserProfile";
import { useGlobalData } from "../../../provider/GlobalDataProvider";

function Topbar({ history }) {
  const { reload } = useGlobalData();

  useEffect(() => {}, [reload]);

  return (
    <div className="kt-header__topbar">
      <SearchDropdown useSVG="true" />

      <QuickPanelToggler />

      <LanguageSelector iconType="" />

      <UIAsideSkin iconType="" />

      <UITheme iconType="" />

      <UserProfile
        history={history}
        showAvatar={true}
        showHi={true}
        showBadge={false}
      />
    </div>
  );
}

export default Topbar;
